const aListElementActionsSecondary = {
  aListElementActionsSecondary: {
    tooltipMove: 'Mover'
  }
}

export default aListElementActionsSecondary
